import { Translate } from '@change-corgi/core/react/i18n';
import { FakeLink } from '@change-corgi/design-system-legacy/components/actions';
import { Box, Flex } from '@change-corgi/design-system-legacy/layout';
import { Heading, Text } from '@change-corgi/design-system-legacy/typography';

import { useDashboardReskinExperiment } from '../../../../hooks/useDashboardReskinExperiment';

import { Task } from './components/Task';
import { useStepsToVictory } from './hooks/useStepsToVictory';
import { StepsToVictory as StepsToVictoryReskin } from './index_new';

export function StepsToVictory() {
	const {
		data: { isEnabled },
	} = useDashboardReskinExperiment();

	const {
		data: {
			tasks,
			stats,
			showDownloadFlyerTask,
			showTaskListToggle,
			toggleTaskListLabel,
			containerRef,
			viewMoreRef,
			getListItemRef,
		},
		actions: { toggleTaskList },
	} = useStepsToVictory();

	if (stats.count === 0) return null;
	if (isEnabled) return <StepsToVictoryReskin />;

	return (
		<Box
			as="section"
			aria-labelledby="steps-to-victory-title"
			data-qa="steps-to-victory-container"
			ref={containerRef}
			mt={32}
			mb={[32, 48]}
		>
			<Flex sx={{ alignItems: 'center', gap: 8 }}>
				<Heading as="h2" size={['h4', 'h3']} id="steps-to-victory-title" data-qa="steps-to-victory-title">
					<Translate value="corgi.petition.starter_dashboard.steps_to_victory.title" />
				</Heading>
				<Box sx={{ borderRadius: 16, backgroundColor: 'neutral-grey100', px: 10, lineHeight: '20px', mt: 4 }}>
					<Text color="typography-secondary" size="small" fontWeight="bold">
						{`${stats.completed}/${stats.count}`}
					</Text>
				</Box>
			</Flex>
			<Flex
				sx={{
					flexDirection: 'column',
					backgroundColor: 'background',
					borderRadius: 'big',
					p: [16, 24],
					mt: 16,
					gap: 24,
				}}
			>
				{tasks.map((task, index) => {
					if (task.name === 'download_flyer' && !showDownloadFlyerTask) return null;

					return (
						<Box key={task.id} ref={getListItemRef(index)} tabIndex={-1}>
							<Task key={task.name} {...task} />
						</Box>
					);
				})}
			</Flex>
			{showTaskListToggle && (
				<FakeLink
					onClick={toggleTaskList}
					data-qa="steps-to-victory-view-more-link"
					ref={viewMoreRef}
					mt={8}
					sx={{ float: 'right', fontSize: '14px' }}
				>
					<Translate value={toggleTaskListLabel} />
				</FakeLink>
			)}
		</Box>
	);
}
